import React, { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import HomeIcon from '@mui/icons-material/Home'
import LockIcon from '@mui/icons-material/Lock'

function Error403() {
  const [theme, setTheme] = useState<"light" | "dark">("light");
  const navigate = useNavigate();

  useEffect(() => {
    const savedTheme = localStorage.getItem("theme") as "light" | "dark";
    const htmlTheme = document.documentElement.getAttribute("data-theme") as
      | "light"
      | "dark";

    if (savedTheme) {
      setTheme(savedTheme);
    } else if (htmlTheme) {
      setTheme(htmlTheme);
    }

    // Listen for theme changes
    const observer = new MutationObserver(() => {
      const currentTheme = document.documentElement.getAttribute(
        "data-theme"
      ) as "light" | "dark";
      if (currentTheme) {
        setTheme(currentTheme);
      }
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["data-theme"],
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className={`w-full h-[500px] flex justify-center items-center ${
      theme === "dark" ? "bg-slate-900" : "bg-slate-100"
    }`}>
      <div className="flex flex-col items-center justify-center gap-4 px-4 text-center">
        {/* Icon */}
        <div className={`p-4 rounded-full ${
          theme === "dark" 
            ? "bg-red-500/20 text-red-400" 
            : "bg-red-100 text-red-500"
        }`}>
          <LockIcon sx={{ fontSize: 40 }} />
        </div>

        {/* Error Code */}
        <h1 className={`text-4xl md:text-5xl font-bold ${
          theme === "dark" ? "text-white" : "text-slate-800"
        }`}>
          403
        </h1>

        {/* Error Title */}
        <h2 className={`text-xl md:text-2xl font-semibold ${
          theme === "dark" ? "text-slate-200" : "text-slate-700"
        }`}>
          Forbidden
        </h2>

        {/* Error Message */}
        <p className={`text-sm md:text-base max-w-sm ${
          theme === "dark" ? "text-slate-400" : "text-slate-600"
        }`}>
          You do not have permission to view this page. Please contact your administrator if you believe this is an error.
        </p>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-3 mt-2">
          <Link
            to="/"
            className={`flex items-center justify-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
              theme === "dark"
                ? "bg-blue-600 hover:bg-blue-700 text-white active:bg-blue-800"
                : "bg-[#174d7a] hover:bg-[#1d5c91] text-white active:bg-[#123b5d]"
            } shadow-md hover:shadow-lg`}
          >
            <HomeIcon sx={{ fontSize: 18 }} />
            Go Back Home
          </Link>
          <button
            onClick={() => navigate(-1)}
            className={`flex items-center justify-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
              theme === "dark"
                ? "bg-slate-700 hover:bg-slate-600 text-slate-200 active:bg-slate-800"
                : "bg-white hover:bg-slate-50 text-slate-700 active:bg-slate-100 border border-slate-200"
            } shadow-md hover:shadow-lg`}
          >
            Go Back
          </button>
        </div>
      </div>
    </div>
  )
}

export default Error403
